module.exports = __webpack_public_path__ + "static/media/Tornax-OT-3240.f3478586.png";